import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {CheckUnregisterVo} from '../../common/shared/api/nicolas/vo/CheckUnregisterVo.interface';

/**
 * 회원 탈퇴 가능 여부 확인
 *
 * Origin: pageNicolasApi.checkUnregister
 * API: GET /auth/v1/unregister/check
 */
export async function getAuthUnregisterCheck(
  options?: FetcherOptions
): Promise<ApiResultVo & {result: CheckUnregisterVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/auth/v1/unregister/check',
    {
      method: 'GET',
    },
    options
  );
  return response.data;
}
